// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_2aJgd","main":"index_main_3ACoB"};